import React from "react";
import { useTranslation } from "react-i18next";

const RestoreCaseBox = ({ handleRestore, beingRestored }) => {
  const { t } = useTranslation();
  return (
    <>
      <div className="restore-case-box">
        {!beingRestored ? (
          <>
            <img src="/assets/icons/check.png" alt="check" width="20" />
            {t("one-case-is-moved-to-trash")}
            <b onClick={handleRestore} style={{ cursor: "pointer" }}>
              <u>{t("Cancel")}</u>{" "}
            </b>
          </>
        ) : (
          <>
            <img src="/assets/icons/loading-icon.png" alt="check" width="15" />
            {t("the-case-is-being-restored")}
          </>
        )}
      </div>
    </>
  );
};

export default RestoreCaseBox;
